var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgFlag03(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "flag-03"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Icon"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M16.3212 2.5H3.33203V10.8333H16.3212C16.7066 10.8333 16.8993 10.8333 17.0094 10.7525C17.1054 10.682 17.1666 10.5739 17.1777 10.4553C17.1903 10.3194 17.0912 10.1541 16.8929 9.82371L16.8929 9.82367L15.2045 7.00966C15.1297 6.88496 15.0923 6.8226 15.0776 6.75604C15.0647 6.69716 15.0647 6.63618 15.0776 6.5773C15.0923 6.51073 15.1297 6.44838 15.2045 6.32367L16.8929 3.50966C17.0912 3.17919 17.1903 3.01395 17.1777 2.878C17.1666 2.75945 17.1054 2.65129 17.0094 2.58082C16.8993 2.5 16.7066 2.5 16.3212 2.5Z",
    fill: "#EF4444"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3.33203 10.8333H16.3212C16.7066 10.8333 16.8993 10.8333 17.0094 10.7525C17.1054 10.682 17.1666 10.5739 17.1777 10.4553C17.1903 10.3194 17.0912 10.1541 16.8929 9.82367L15.2045 7.00966C15.1297 6.88496 15.0923 6.8226 15.0776 6.75604C15.0647 6.69716 15.0647 6.63618 15.0776 6.5773C15.0923 6.51073 15.1297 6.44838 15.2045 6.32367L16.8929 3.50966C17.0912 3.17919 17.1903 3.01395 17.1777 2.878C17.1666 2.75945 17.1054 2.65129 17.0094 2.58082C16.8993 2.5 16.7066 2.5 16.3212 2.5H3.33203L3.33203 17.5",
    stroke: "#EF4444",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFlag03);
export default __webpack_public_path__ + "static/media/flag-03.beecbb9620453b0d974404ae279e4eca.svg";
export { ForwardRef as ReactComponent };